import * as React from 'react';
import classNames from 'classnames';
import Dot from '../../atoms/Dot';
import Subtitle from '../../atoms/Subtitle';

import styles from './TableFootnote.module.scss';

export interface Props extends React.HTMLAttributes<HTMLElement> {
  className?: string;
}

export const TableFootnote: React.FunctionComponent<Props> = ({
  className,
  ...htmlElementProps
}) => (
  <div className={classNames(styles.footnote, className)} {...htmlElementProps}>
    <Subtitle className="mb-2" size="sm2">
      TMR: Tempo Médio de Resposta
    </Subtitle>

    <Subtitle as="span" className="d-flex" size="sm2">
      <div className="d-flex flex-items-center mr-5">
        <Dot color="var(--q24-color-red400)" />
        <span>Mais lento que a média</span>
      </div>
      <div className="d-flex flex-items-center mr-5">
        <Dot color="var(--q24-color-yellow400)" />
        <span>Igual à média</span>
      </div>
      <div className="d-flex flex-items-center">
        <Dot color="var(--q24-color-green400)" />
        <span>Mais rápido que a média</span>
      </div>
    </Subtitle>
  </div>
);

export default TableFootnote;
